<!-- Nav Menu -->

<template>
  <div id="app">
    <!-- <Menu @season="setSeason" :foot='false' :config="env"/> -->
    <transition name="fade" appear> <router-view :key="$route.fullPath" :season='season' :config='env'/></transition>
    <!-- <Footer :config="env"/> -->
  </div>
</template>

<style>
a {
  color: #337ab7!important;
  text-decoration: none;
  background-color: transparent;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
 
.fade-enter-active {
  transition-delay: .5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#app {
  font-family: 'Gantari', sans-serif!important;
  font-size: 14pt;
  font-weight: 500;
  /* background-color: rgb(249, 249, 249); */
}
li.nav-item::marker {
  color: transparent;
}

@media only screen and (max-width: 480px) {
  #app {
    font-size: 10pt;
  }
}


@media (min-width: 1200px){
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1279px!important;
  }
}
</style>

<script>
// import Menu from "@/components/menu.vue";
// import Footer from "@/components/footer.vue";

export default {
  components: {
    // Menu,
    // Footer
  },
  data(){
    return{
      course:'',
      currentReport:'',
      season:'',
      env:[]
    }
  },
      methods: {
        // Define method that will use the payload to update the data property
            setSeason(payload) {
            this.season = payload.season
        },

    },
    mounted(){
      this.env=process.env
    }
};
</script>
